export const ENVIRONMENT_SELECTOR_KEY = 'environment_selector'
